import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { SubmissionReviewActivityLogEntry } from "../../types";

interface Props {
  entries: SubmissionReviewActivityLogEntry[];
}

export function ActivityLogView({ entries }: Props) {
  const [t] = useTranslation();

  if (entries.length === 0) return null;

  return (
    <Card variant="outlined">
      <CardHeader
        title={String(t("Activity"))}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardContent sx={{ pt: 0 }}>
        <List dense>
          {entries.map((entry) => (
            <ListItem key={entry.id} sx={{ px: 0 }}>
              <ListItemText
                primary={entry.label}
                secondary={dayjs(entry.created).format("MM/DD/YYYY hh:mm A")}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
